import { models } from 'feathers-vuex';

const state = {
    translations: null,
    frenchTexts: null,
    language: null,
    babelMode: false
};

const mutations = {
    'SET_TRANSLATIONS'(state, translations) { state.translations = translations },
    'SET_FRENCH_TEXTS'(state, translations) { state.frenchTexts = translations },
    'SET_TRANSLATION'(state, translation) {
        state.translations[translation.key] = translation.text;
    },
    'REMOVE_TRANSLATION'(state, translation) {
        delete state.translations[translation.key];
    },
    'SET_BABEL_MODE'(state, babelMode) { state.babelMode = babelMode},
    'SET_LANGUAGE'(state, language) {state.language = language}
};

const actions = {
    setTranslation: async ({ commit, getters }, translation) => {
        if (!translation) return;
        if (translation.text) translation.text = translation.text.trim();

        let response = await models.api.Translation.find({ query: { language: getters.language, key: translation.key } });

        if (response.total > 0) {
            let t = response.data[0];

            if (translation.text.length < 1) {
                console.debug("traduction existante, suppression");
                t.remove();
            } else {
                console.debug("traduction existante, modification", t);
                t.text = translation.text;
                await t.save();
            }
        }
        else {
            if (translation.text.length > 0) {
                console.debug("Création d'une nouvelle traduction")
                let t = new models.api.Translation({
                    language: getters.language,
                    key: translation.key,
                    text: translation.text
                })
                await t.create();
            }
        }

        if (translation.text.length < 1) {
            commit('REMOVE_TRANSLATION', translation);
        } else {
            commit('SET_TRANSLATION', translation);
        }
    },

    setLanguage: async ({ commit }, language) => {
        commit('SET_LANGUAGE', language);
        commit('SET_TRANSLATIONS', await loadTextsIn(language));
        commit('SET_FRENCH_TEXTS', await loadTextsIn('fr'));
    },

    reloadTranslations: async ({ commit, getters }) => {
        commit('SET_TRANSLATIONS', await loadTextsIn(getters.language));
        commit('SET_FRENCH_TEXTS', await loadTextsIn('fr'));
    },

    setBabelMode: ({commit}, babelMode) => commit('SET_BABEL_MODE', babelMode)
};

const getters = {
    translations: state => state.translations,
    frenchTexts: state => state.frenchTexts,
    language: state => state.language,
    babelMode: state => state.babelMode,
    foreignLanguage: state => state.language != 'fr'
};

export default {
    state,
    mutations,
    actions,
    getters
};

async function loadTextsIn(language) {
    let blockSize = 40;
    let response = await models.api.Translation.find({ query: { language: language, $limit: blockSize } });
    let translationsList = response.data;
    let steps = response.total / blockSize;

    for (let i = 1; i < steps; i++) {
        response = await models.api.Translation.find({ query: { language: language, $limit: blockSize, $skip: i * blockSize } });
        translationsList = translationsList.concat(response.data);
    }

    return translationsList.reduce((acc, val) => {
        acc[val.key] = val.text;
        return acc;
    }, {});
}
